import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import {
  Ch_approveReferralLetterInput,
  useChApproveReferralDocumentMutation as useChApproveReferralDocumentMutationType,
} from "@/modules/patients/detail/referral/ch/services/__generated__/useChApproveReferralDocumentMutation.graphql"

const approveDocumentMutation = graphql`
  mutation useChApproveReferralDocumentMutation($input: Ch_approveReferralLetterInput!) {
    ch_approveReferralLetter(input: $input) {
      ch_ReferralLetter {
        id
        progressNoteId
        fileId
        fileMetadata {
          documentType
          extension
          lengthInKilobytes
        }
        signedAt
        signedBy
        updatedAt
        updatedBy
      }
      errors {
        ... on DocumentDoesNotExist {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useChApproveReferralDocumentMutationType>, "variables"> & {
  id: Ch_approveReferralLetterInput["id"]
}

export const useChApproveReferralDocumentMutation = () => {
  const [commit, isLoading] = useMutation<useChApproveReferralDocumentMutationType>(approveDocumentMutation)

  const commitHandler = useCallback(
    async (config: Config) => {
      commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isLoading] as const
}
